import React from 'react';
import type { TFunction } from 'i18next';
import { formatCurrency } from '../../../utils/formatCurrency';
import { CARD_SHADOW } from '../constants';

export interface PayrollCardProps {
  payrollName: string;
  payrollDesc: string;
  payrollTotal: number;
  payrollPromoBase: number;
  perEmployee: number;
  employeeCount: number;
  language: string;
  t: TFunction;
  onChange: () => void;
}

export function PayrollCard({ payrollName, payrollDesc, payrollTotal, payrollPromoBase, perEmployee, employeeCount, language, t, onChange }: PayrollCardProps): React.ReactElement {
  return (
    <div className="mb-3.5 rounded-xl border border-hairline bg-white" style={{ padding: "22px 24px", boxShadow: CARD_SHADOW }}>
      <div className="mb-3.5 flex items-start justify-between gap-4">
        <div className="flex-1">
          <div className="inline-block rounded border font-extrabold" style={{ fontSize: 10, color: "#14532D", background: "#F0FDF4", borderColor: "#DCFCE7", padding: "3px 10px", letterSpacing: "0.08em" }}>{t("cart.labels.addon")}</div>
          <div className="mt-2.5 font-extrabold text-ink" style={{ fontSize: 20, letterSpacing: "-0.01em" }}>{payrollName}</div>
          <div className="mt-1 text-small text-sub leading-normal">{payrollDesc}</div>
        </div>
        <div className="whitespace-nowrap text-right">
          <div className="font-extrabold text-ink" style={{ fontSize: 22 }}>{formatCurrency(payrollTotal, language)}</div>
          <div className="mt-0.5 text-tiny text-muted">{t("cart.perMonth")}</div>
        </div>
      </div>
      <div className="flex gap-6 border-t border-hairline pt-3.5 text-tiny">
        <div><div className="text-muted">{t("cart.metrics.base")}</div><div className="mt-0.5 font-bold text-ink">{formatCurrency(payrollPromoBase, language)}{t("common.perMoShort")}</div></div>
        <div><div className="text-muted">{t("cart.metrics.perEmployee")}</div><div className="mt-0.5 font-bold text-ink">{formatCurrency(perEmployee, language)}{t("common.perMoShort")}</div></div>
        <div><div className="text-muted">{t("cart.labels.employees")}</div><div className="mt-0.5 font-bold text-ink">{employeeCount}</div></div>
      </div>
      <button onClick={onChange} className="mt-3.5 cursor-pointer rounded-[10px] border border-stroke bg-white px-4 py-2 text-small font-semibold text-ink font-sans" style={{ boxShadow: "0 1px 2px rgba(0,0,0,0.05)" }}>{t("cart.change")} payroll</button>
    </div>
  );
}
